import { MaterialCommunityIcons } from "@expo/vector-icons";
import { Button, Center, HStack, Icon, Text } from "native-base";
import React from "react";

import { useAppNavigation } from "@/hooks/application/navigation";
import { useAppSelector } from "@/hooks/application/store";
import { RootNavigation } from "@/navigation/Root";
import { formatToCurrency } from "@/utils/helpers";

const HearderCartButton = () => {
  const { navigate } = useAppNavigation<RootNavigation>();
  const subtotal = useAppSelector((store) => store.checkout.subtotal);
  return (
    <Button variant="ghost" px="4" onPress={() => navigate("cartStack", { screen: "cart" })}>
      <HStack alignItems="center">
        <Center w="40px" h="40px" bgColor="primary.600" rounded="full" p="1" shadow="8">
          <Icon as={<MaterialCommunityIcons name="cart-outline" />} color="white.50" size="lg" />
        </Center>
        <Text color="primary.600" fontSize="lg" bold pl="2">
          {formatToCurrency(subtotal)}
        </Text>
      </HStack>
    </Button>
  );
};

export default HearderCartButton;
